module.exports = __webpack_public_path__ + "img/network-icon.1cd373a4.svg";